<template>
  <div v-if="isPopupOpen" class="device__info-popup">
    <div class="info-popup__top">
      <!-- <div class="device-info__photo">
          <img class="device-image" alt="device" :src="getImageUrl" />
          </div> -->
      <div>
        <div class="h-[70px] overflow-hidden p-[1px]">
          <img class="max-w-[48px]" :src="getImageUrl" alt="device" />
        </div>
        <div class="photo-tile"></div>
      </div>
      <div class="info-popup__device-name">
        <p class="info-popup__text text-secondary-base dark:text-secondary-100">
          {{ deviceInfo.model }}
        </p>
        <p class="info-popup__text text-secondary-400 dark:text-greyscale-500">
          {{ deviceInfo.brand }}
        </p>
      </div>
      <svg
        @click="closePopup"
        class="closed-popup-info"
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="12.728"
          cy="12.7279"
          r="9"
          transform="rotate(45 12.728 12.7279)"
          fill="#212328"
        />
        <path
          d="M14.9669 16.0571L16.0583 14.9657L10.4899 9.3972L9.39846 10.4886L14.9669 16.0571Z"
          fill="white"
        />
        <path
          d="M10.4899 16.0582L16.0583 10.4897L14.9669 9.39829L9.39846 14.9668L10.4899 16.0582Z"
          fill="white"
        />
      </svg>
    </div>
    <div class="info-popup__bottom">
      <div class="device-info">
        <p>{{ $t("device.spec.version") }}:</p>
        <p>{{ deviceInfo.version }}</p>
        <p>{{ $t("device.spec.resolution") }}:</p>
        <p>{{ deviceInfo.resolution }}</p>
        <p>{{ $t("device.spec.size") }}:</p>
        <p>{{ deviceInfo.size }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DeviceInfoPopup",
  props: {
    isPopupOpen: Boolean,
    deviceInfo: Object,
  },
  methods: {
    closePopup() {
      this.$emit("popupStatus", false);
    },
  },
  computed: {
    getImageUrl() {
      return require(`@/assets/images/devices/${this.deviceInfo.iconTag}`);
    },
  },
};
</script>
<style>
.device__info-popup {
  @apply w-[232px] p-4 bg-primary-white dark:bg-dark-mode-150 border dark:border-dark-mode-150 rounded-xl z-50 flex flex-col gap-3 absolute left-[177px] top-[87px] z-10 dark:shadow-none;
  box-shadow: 0px 0px 62px rgba(113, 128, 150, 0.14);
}
.info-popup__top {
  @apply flex gap-[10px] items-center;
}
.info-popup__top svg circle {
  @apply fill-[#464C5C];
}
.closed-popup-info {
  @apply absolute right-[8px] top-[9px] w-[18px] h-[18px] cursor-pointer;
}
.device-info {
  @apply grid grid-cols-2 gap-x-2;
}
.device-info p {
  @apply text-xs font-medium text-greyscale-700 dark:!text-secondary-100;
}
.device-info__photo {
  @apply h-[180px] overflow-hidden px-[2px] max-w-[145px];
}
.info-popup__device-name {
  @apply flex gap-1 flex-col;
}
.info-popup__text {
  @apply text-xs font-semibold;
}
.photo-tile {
  @apply h-[3px] w-full bg-[#A9A3AD];
}
</style>
